import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="specific--oas-pruefung"
export default class extends Controller {
  static targets = [
    "programmSelect", // Wird bei Dressur Form verwendet
    "stufenFeld", "stufenTemplate", // Wird beim Springen und CC Form verwendet
    "teilpruefungInputWrapper",
    "gewinnpunkteWrapper"
  ]
  static values = {
    kategorieIdsFuerProgramme: Array,
    kategorieIdsFuerProgrammeNoLimit: Array,
    maxAnzahlProgramme: Number
  }

  connect() {
    document.querySelector('select[name*="[kategorie_id]"]')?.addEventListener("change", (event) => {
      this.setProgrammVisibility(event)
    })
    document.querySelector('select[name*="[kategorie_id]"]')?.addEventListener("tomselect:initialized", (event) => {
      setTimeout(() => {
        this.setProgrammVisibility(event)
      }, 100)
    })
  }

  // Programm Select darstellen/ausblenden und maxItems setzen
  setProgrammVisibility(event) {
    if (!this.hasProgrammSelectTarget) return

    const selectedKategorie = parseInt(event.target.value)
    if (this.kategorieIdsFuerProgrammeValue.includes(selectedKategorie)) {
      this.programmSelectTarget.disabled = false
      this.programmSelectTarget.tomselect.enable()
      if (this.programmSelectTarget.tomselect.items.length > this.maxAnzahlProgrammeValue) {
        this.programmSelectTarget.tomselect.clear()
      }
      this.programmSelectTarget.tomselect.settings.maxItems = this.maxAnzahlProgrammeValue
    } else if (this.kategorieIdsFuerProgrammeNoLimitValue.includes(selectedKategorie)) {
      this.programmSelectTarget.disabled = false
      this.programmSelectTarget.tomselect.enable()
      this.programmSelectTarget.tomselect.settings.maxItems = null
    } else {
      this.programmSelectTarget.disabled = true
      this.programmSelectTarget.tomselect.disable()
      this.programmSelectTarget.tomselect.clear()
    }
  }

  // Neue Stufen Felder hinzufügen/entfernen
  updateStufenFelder(event) {
    const gewuenschteAnzahlStufen = parseInt(event.target.value);
    const aktuelleAnzahlStufen = this.stufenFeldTargets.length;

    if (gewuenschteAnzahlStufen > aktuelleAnzahlStufen) {
      for (let i = aktuelleAnzahlStufen; i < gewuenschteAnzahlStufen; i++) {
        const template = this.stufenTemplateTarget.innerHTML.replace(/idx/g, this.idx);
        this.stufenTemplateTarget.insertAdjacentHTML("beforebegin", template);
      }
    } else if (gewuenschteAnzahlStufen < aktuelleAnzahlStufen) {
      for (let i = aktuelleAnzahlStufen; i > gewuenschteAnzahlStufen; i--) {
        this.stufenFeldTargets[i - 1]?.remove();
      }
    }
  }

  // Teilprüfungs Inputs ein-/ausblenden und Werte zurücksetzen
  updateTeilpruefungInputs(event) {
    const { disziplin } = event.params
    const isChecked = event.target.checked
    const wrapper = this.teilpruefungInputWrapperTargets.find((element) => element.dataset.disziplin === disziplin)
    if (wrapper) {
      if (isChecked) {
        wrapper.classList.remove("d-none")
      } else {
        wrapper.classList.add("d-none")
        wrapper.querySelectorAll("input, select, textarea").forEach((field) => {
          field.value = ""
        })
      }
    }

    // Ausnahme für CC Springen: Stufen Felder aktualisieren
    if (disziplin === "concours_complet_springen") {
      if (isChecked) {
        document.querySelector('.springen-anzahl-stufen-fuer-teilpruefung').classList.remove("d-none")
      } else {
        document.querySelector('input[name*="springen_anzahl_stufen"]').value = 0
        document.querySelector('input[name*="springen_anzahl_stufen"]').dispatchEvent(new Event('input')) // Damit `updateStufenFelder` aufgerufen wird
        document.querySelector('.springen-anzahl-stufen-fuer-teilpruefung').classList.add("d-none")
      }
    }
  }

  toggleGewinnpunkteVisibility(event) {
    const isChecked = event.target.checked
    if (isChecked) {
      this.gewinnpunkteWrapperTarget.classList.remove("d-none")
    } else {
      this.gewinnpunkteWrapperTarget.classList.add("d-none")
      this.gewinnpunkteWrapperTarget.querySelectorAll("input, select, textarea").forEach((field) => {
        field.value = ""
      })
    }
  }

  get idx() {
    return this.stufenFeldTargets.length + 1;
  }
}
